<span *ngIf="date">{{ fromNow ? timeFromNow() : (date | amCalendar: dateFormat) }}</span>
